<template>
  <b-card no-body :id="'widgetppt' + widget.id" ref="gallery">
    <div class="card-header" :class="{fixedCardHeader: isOverflown}">
      <span v-b-tooltip.hover :title="title" class="widget-title">{{title}}</span>
      <settings-button />
    </div>
    <b-card-body class="p-3 clearfix" @click="handleClickThrough">
      <div class="text-muted text-center text-uppercase font-weight-bold font-xs">
        <span class="loading-text" v-if='!loaded'>LOADING...</span>
        <div v-show='goodChart'>
          <carousel :per-page="perPage" :mouse-drag="false">
            <slide v-for='(item, index) in items' v-bind:key="item.caption">
              <template v-if="item.image_url">
                <img :src="item.image_url" width=400 />
                <br>
                <h5 class="img-title">{{ item.name }}</h5>
                <p v-if="item.start_date" class="img-date">Valid {{ dateFormat(item.start_date) }} - {{ dateFormat(item.end_date) }}</p>
              </template>
              <template v-else-if="item.summary">
                <div class="text-box px-3 py-2 m-3">
                  <h5>{{ item.client_name }}</h5>
                  <p class="date">{{ dateFormat(item.start_date) }} - {{ dateFormat(item.end_date) }}</p>
                  <p class="summary">{{ item.summary}}</p>
                  <p class="author">- {{ item.user }}</p>
                </div>
              </template>
              <template v-else>
                <leaflet-chart :index="index" :campaignTarget="campaignTarget" :mapCenter="mapCenter"/>
                <br>
                <h5 class="img-title">Campaign: {{ item.campaign_name }}</h5>
              </template>
            </slide>
          </carousel>
        </div>
        <div v-show="!goodChart">
          <h5 v-if="widget.title === 'Account Summary'">No Report Available</h5>
          <h5 v-else>No data available</h5>
        </div>
      </div>
    </b-card-body>
    <div class="comparison-disclaimer" v-if="this.widget.disableDataComparison"><sup>*</sup>Data comparison unavailable</div>
  </b-card>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { base_widget } from '@/views/widgets/base_widget'
import SettingsButton from '@/views/buttons/SettingsButton'
import LeafletChart from '@/views/charts/LeafletChart'
import Moment from 'moment'

export default {
  name: 'GalleryWidget',
  mixins: [base_widget],
  components: {
    SettingsButton,
    LeafletChart,
    Carousel,
    Slide
  },

  data () {
    return {
      perPage: 1,
      items: [],
      goodChart: true,
      loaded: false,
      campaignTarget: [],
      mapCenter: []
    }
  },
  methods: {
    setData (response){
      this.items = response.data.data
      
      for (const prop of this.items){
        this.campaignTarget.push(prop.target_data)
        this.mapCenter.push(prop.map_center)
      }
      if (this.items.length < 1) {
        this.goodChart = false
        this.saveWidgetData({}, [])
      }
      this.loaded = true
      this.saveWidgetData({}, [])
    },

    dateFormat (date) {
      return Moment(date).format('ll')
    }
  }
}
</script>

<style scoped>
  .text-box {
    position: relative;
    display: inline-block;
    color: #3493B2;
    background: #ECF6F9;
    border-radius: 6px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
    text-align: left;
    vertical-align: top;
  }
  .text-box h5 {
    margin-bottom: 0;
  }
  .text-box .author, .text-box .date, .text-box h5, h5.img-title, .img-date {
    font-family: 'Cooper Hewitt Medium';
    letter-spacing: 2px;
  }
  .text-box .date, .img-date {
    text-transform: none;
  }
  .text-box .summary {
    text-transform: none;
    color: #333;
    font-weight: 400;
  }
  h5.img-title {
    margin-top: 15px;
  }
  .loading-text {
    color: #757575;
    text-align: center;
    margin-top: 10px;
    text-transform: uppercase;
    font-family: 'Cooper Hewitt Semibold';
    letter-spacing: 3px;
  }
</style>